<template>
    <submenu-page
        eyebrow="STUDENT SERVICES"
        title="Admission Management"
        description="Review online applications and manage admission and entrance examination workflows."
        count-label="admission tools"
    >
        <SubMenu />
    </submenu-page>
</template>
<script>


import SubMenu from './SubMenu.vue';
export default {
  components: {
    SubMenu
  },
  data() {
    return {
      accessDetails: null,
    };
  },
  mounted() {
    this.accessDetails = this.$store.getters['auth/_user'];   
    if (this.accessDetails.isSchoolStaff == false) {
      this.$store.dispatch('auth/Logout')
      this.$router.push('/login')
    }
  }
};
</script>
<style></style>
